import Vue from 'vue';
import Router from 'vue-router';
import SignupPage from './views/SignupPage.vue';
import AccountSetup from './views/account-setup/AccountSetup.vue';
import MemberType from './views/account-setup/MemberType.vue';
import Organization from './views/account-setup/Organization.vue';
import PaymentInformation from './views/account-setup/PaymentInformation.vue';
import MainLayout from './views/MainLayout.vue';
import Users from './views/Users.vue';
import ApiIntegration from './views/ApiIntegration.vue';
import AddAPIKeyModal from './views/modal/AddAPIKeyModal.vue';
import AccessKeyList from './views/AccessKeyList.vue';
import Setting from './views/Setting.vue';
import Requests from './views/Requests.vue';
import RequestPanel from './views/RequestPanel.vue';
import ServiceRequestModal from './views/service-request/ServiceRequestModal.vue';
import ServiceVisit from './views/service-request/ServiceVisit.vue';
import VehicleLanguage from './views/service-request/VehicleLanguage.vue';
import AddressBilling from './views/service-request/AddressBilling.vue';
import Confirmation from './views/service-request/Confirmation.vue';
import AddPatientModal from './views/modal/AddPatientModal.vue';
import AddMemberModal from './views/modal/AddMemberModal.vue';
import AddLocationModal from './views/modal/AddLocationModal.vue';
import UpdateLocationModal from './views/modal/UpdateLocationModal.vue';
import UpdateMemberModal from './views/modal/UpdateMemberModal.vue';
import ViewPatientModal from './views/modal/ViewPatientModal.vue';
import ViewRequestDetailModal from './views/modal/ViewRequestDetailModal.vue';
import UpdatePatientModal from './views/modal/UpdatePatientModal.vue';
import ViewReceiptModal from './views/modal/ViewReceiptModal.vue';
import ViewInvoicePayModal from './views/modal/PayInvoiceModal.vue';
import RescheduleRequestModal from './views/modal/RescheduleRequestModal.vue';
import ServiceRequestDetails from './views/ServiceRequestDetails.vue';
import MeetingDetails from './views/service-request/MeetingDetails.vue';
import { MedTransGoConstants } from './util/constants';
import Invoices from './views/Invoices.vue';
import SubscriptionPlans from './views/account-setup/SubscriptionPlans.vue';
import UpdateHealthCareProviderModal from './views/modal/UpdateHealthCareProviderModal.vue';
import UpdateRxProviderModal from './views/modal/UpdateRxProviderModal.vue';
import pickupDetails from './views/service-request/PickupDetails.vue';
import Calendar from './views/Calendar.vue';
import SubscriptionPlan from './components/SubscriptionPlan.vue';
import ApproveAuctionModal from './views/modal/ApproveAuctionModal.vue';
import Reports from './views/Reports.vue';
import Dashboard from './views/Dashboard.vue';
import UploadBatchRequestModal from './views/modal/UploadBatchRequestModal.vue';

Vue.use(Router);
const newServiceRequest = {
  path: MedTransGoConstants.URL_NEW_SERVICE_REQUEST,
  name: MedTransGoConstants.VIEW_NEW_SERVICE_REQUEST,
  component: ServiceRequestModal,
  children: [
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_SERVICE_VISIT,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_SERVICE_VISIT,
      component: ServiceVisit,
    },
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_VEHICLE_LANGUAGE,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_VEHICLE_LANGUAGE,
      component: VehicleLanguage,
    },
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_MEETING_DETAILS,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_MEETING_DETAILS,
      component: MeetingDetails,
    },
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_ADDRESS_BILLING,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_ADDRESS_BILLING,
      component: AddressBilling,
    },
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_PICKUP_DETAILS,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_PICKUP_DETAILS,
      component: pickupDetails,
    },
    {
      path: MedTransGoConstants.URL_SERVICE_REQUEST_CONFIRMATION,
      name: MedTransGoConstants.VIEW_SERVICE_REQUEST_CONFIRMATION,
      component: Confirmation,
    },
  ],
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: MedTransGoConstants.URL_SIGNUP,
      name: MedTransGoConstants.VIEW_SIGNUP_NAME,
      pathToRegexpOptions: {
        strict: true,
      },
      component: SignupPage,
    },
    {
      path: MedTransGoConstants.URL_SUBSCRIPTION_PLAN,
      name: MedTransGoConstants.VIEW_SUBSCRIPTION_PLAN_NAME,
      pathToRegexpOptions: {
        strict: true,
      },
      component: SubscriptionPlan,
    },
    {
      path: MedTransGoConstants.URL_ACCOUNT_SETUP,
      component: AccountSetup,
      children: [
        {
          path: MedTransGoConstants.URL_MEMBER_TYPE,
          name: MedTransGoConstants.VIEW_MEMBER_TYPE_NAME,
          component: MemberType,
        },
        {
          path: MedTransGoConstants.URL_ORGANIZATION,
          name: MedTransGoConstants.VIEW_ORGANIZATION_NAME,
          component: Organization,
        },
        {
          path: MedTransGoConstants.URL_SUBSCRIPTION_PLANS,
          name: MedTransGoConstants.VIEW_SUBSCRIPTION_PLANS_NAME,
          component: SubscriptionPlans,
        },
        {
          path: MedTransGoConstants.URL_PAYMENT_INFORMATION,
          name: MedTransGoConstants.VIEW_PAYMENT_INFORMATION_NAME,
          component: PaymentInformation,
        },
      ],
    },
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          path: MedTransGoConstants.URL_REQUESTS,
          name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME,
          component: RequestPanel,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_NAME,
              component: ServiceRequestDetails,
              children: [
                {
                  path: MedTransGoConstants.URL_UPLOAD_BATCH_REQUEST_VIA_EXCEL,
                  name: MedTransGoConstants.VIEW_UPLOAD_BATCH_REQUEST_VIA_EXCEL,
                  component: UploadBatchRequestModal,
                },
                {
                  path: MedTransGoConstants.URL_RESCHEDULE_REQUEST,
                  name: MedTransGoConstants.VIEW_RESCHEDULE_REQUEST,
                  component: RescheduleRequestModal,
                },
                {
                  path: MedTransGoConstants.URL_APPROVE_AUCTION_REQUEST,
                  name: MedTransGoConstants.VIEW_APPROVE_AUCTION_REQUEST,
                  component: ApproveAuctionModal,
                },
                newServiceRequest,
              ],
            },
            newServiceRequest,
          ],
        },
        newServiceRequest,
        {
          path: MedTransGoConstants.URL_USERS,
          name: MedTransGoConstants.VIEW_USERS_NAME,
          component: Users,
          children: [
            {
              path: MedTransGoConstants.URL_ADD,
              name: MedTransGoConstants.VIEW_ADD_PATIENT_NAME,
              component: AddPatientModal,
            },
            {
              path: 'patients/:id',
              name: MedTransGoConstants.VIEW_VIEW_PATIENT_NAME,
              component: ViewPatientModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE,
              name: MedTransGoConstants.VIEW_UPDATE_PATIENT_NAME,
              component: UpdatePatientModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_HEALTHCARE_PROVIDER + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_HEALTHCARE_PROVIDER_NAME,
              component: UpdateHealthCareProviderModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_RX_PROVIDER + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_RX_PROVIDER_NAME,
              component: UpdateRxProviderModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_API_INTEGRATION,
          name: MedTransGoConstants.VIEW_API_INTEGRATION_NAME,
          component: ApiIntegration,
          children: [
            {
              path: MedTransGoConstants.URL_ACCESS_KEY_LIST,
              name: MedTransGoConstants.URL_ADD_ACCESS_KEY,
              component: AccessKeyList,
              children: [
                {
                  path: MedTransGoConstants.URL_ADD_ACCESS_KEY,
                  name: MedTransGoConstants.VIEW_ADD_API_KEY_NAME,
                  component: AddAPIKeyModal,
                },
              ],
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_INVOICE_PANEL,
          name: MedTransGoConstants.VIEW_INVOICE_PANEL_NAME,
          component: Invoices,
          children: [
            {
              path: MedTransGoConstants.URL_VIEW_ORDER,
              name: MedTransGoConstants.VIEW_VIEW_ORDER,
              component: ViewRequestDetailModal,
            },
            {
              path: MedTransGoConstants.URL_INVOICE_PAY,
              name: MedTransGoConstants.VIEW_INVOICE_PAY_NAME,
              component: ViewInvoicePayModal,
            },
            {
              path: MedTransGoConstants.URL_INVOICE_RECEIPT,
              name: MedTransGoConstants.VIEW_INVOICE_RECEIPT_NAME,
              component: ViewReceiptModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_CALENDAR,
          name: MedTransGoConstants.VIEW_CALENDAR_NAME,
          component: Calendar,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_MODAL_NAME,
              component: ViewRequestDetailModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_SETTING,
          name: MedTransGoConstants.VIEW_SETTING_NAME,
          component: Setting,
          children: [
            {
              path: MedTransGoConstants.URL_ADD_MEMBER,
              name: MedTransGoConstants.VIEW_ADD_MEMBER_NAME,
              component: AddMemberModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_MEMBER + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_MEMBER_NAME,
              component: UpdateMemberModal,
            },
            {
              path: MedTransGoConstants.URL_UPDATE_LOCATION + '/:id',
              name: MedTransGoConstants.VIEW_UPDATE_LOCATION_NAME,
              component: UpdateLocationModal,
            },
            {
              path: MedTransGoConstants.URL_ADD_LOCATION,
              name: MedTransGoConstants.VIEW_ADD_LOCATION_NAME,
              component: AddLocationModal,
            },
          ],
        },
        {
          path: MedTransGoConstants.URL_REPORTS,
          name: MedTransGoConstants.VIEW_REPORTS_NAME,
          component: Reports,
        },
        {
          path: MedTransGoConstants.URL_DASHBOARD,
          name: MedTransGoConstants.VIEW_DASHBOARD_NAME,
          component: Dashboard,
        },
        {
          path: MedTransGoConstants.URL_REQUESTS_TABLE,
          name: MedTransGoConstants.VIEW_REQUESTS_TABLE_NAME,
          component: Requests,
          children: [
            {
              path: ':id',
              name: MedTransGoConstants.VIEW_REQUEST_DETAILS_MODAL_NAME,
              component: ViewRequestDetailModal,
              children: [
                {
                  path: MedTransGoConstants.URL_RESCHEDULE_REQUEST,
                  name: MedTransGoConstants.VIEW_RESCHEDULE_REQUEST,
                  component: RescheduleRequestModal,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
